import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { useTranslation } from "react-i18next";
// INTERFACES
import { FEMessage } from "../../../../../interfaces/AdapterCdoModbus.interface";
// COMPONENTS
import FormInputNumber from "../../../../components/form/FormInputNumber";
import FormSelectMessage from "../../../../components/form/FormSelectMessage";
import FormInputBooleanSwitch from "../../../../components/form/FormInputBooleanSwitch";

export default function ComponentMsg({
	value,
	onChange,
	disabledInput = false,
}: {
	value: FEMessage;
	onChange: (newValue: FEMessage) => void;
	disabledInput?: boolean;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [hasPosition, setHasPosition] = useState<boolean>(value.msg.position !== null);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeMsgId = (newValue: string) => {
		onChange({
			...value,
			msg: {
				...value.msg,
				msg_id: newValue,
			},
		});
	};

	const onChangePosition = (newValue: number) => {
		onChange({
			...value,
			msg: {
				...value.msg,
				position: newValue,
			},
		});
	};

	const onChangeHasPosition = (newValue: boolean) => {
		setHasPosition(newValue);
		onChange({
			...value,
			msg: {
				...value.msg,
				position: newValue ? 0 : null,
			},
		});
	};

	const onChangeActive = (newValue: boolean) => {
		onChange({
			...value,
			msg: {
				...value.msg,
				active: newValue,
			},
		});
	};

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		setHasPosition(value.msg.position !== null);
	}, [value.msg.position]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='container'>
			<FormSelectMessage
				inputValue={value.msg.msg_id}
				inputOnChange={onChangeMsgId}
				disabledInput={disabledInput}
				displaySelect
			/>

			<FormInputBooleanSwitch
				value={hasPosition}
				onChangeSwitch={(newValue: boolean) => onChangeHasPosition(newValue)}
				labelName={`Has ${t("general.position")}`}
				variableName='has_position'
				isRequired={false}
				disabledInput={disabledInput}

			/>

			{hasPosition && (
				<FormInputNumber
					inputValue={value.msg.position ?? 0}
					inputOnChange={(newValue: number) => onChangePosition(newValue)}
					inputLabelName={`LN2 ${t("general.position")}`}
					inputVariableName='position'

				/>
			)}

			<FormInputBooleanSwitch
				value={value.msg.active}
				onChangeSwitch={(newValue: boolean) => onChangeActive(newValue)}
				labelName={`LN2 ${t("general.active")}`}
				variableName='active'
				isRequired
				disabledInput={disabledInput}

			/>
		</div>
	);
}
